// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__22k-T","text":"SelectPayment_text__TVkii","title":"SelectPayment_title__APFrm","btn":"SelectPayment_btn__N0PTX"};